import React from "react";
import Search from "@mui/icons-material/Search";
import HelpOutline from "@mui/icons-material/HelpOutline";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import Person from "@mui/icons-material/Person";
import Article from "@mui/icons-material/Article";
import CorporateFare from "@mui/icons-material/CorporateFare";
import ImportContacts from "@mui/icons-material/ImportContacts";
import { HumMenus } from "../../../type/componentsType/TkMenu";

export const standardMenu: HumMenus[] = [
  {
    name: "照会する",
    icon: <Search />,
    options: [
      {
        name: "共済契約者ホーム",
        path: "/SCRC020001",
      },
      {
        name: "契約者情報",
        path: "/SCRC040101",
        setBusinessType: "JOB-114",
      },
      {
        name: "施設一覧",
        path: "/SCRC050030",
      },
      {
        name: "法人職員一覧",
        path: "/SCRC060033",
        setBusinessType: "JOB-25",
        param: {
          systemMenuFlg: true,
        },
      },
      {
        name: "退職者状況一覧",
        path: "/SCRC060031",
      },
    ],
  },
  {
    name: "法人担当者情報",
    icon: <ManageAccounts />,
    options: [
      {
        name: "契約者・法人担当者情報の確認・変更",
        path: "/SCRC040106",
      },
      {
        name: "代行者登録の設定",
        path: "/SCRC100003",
      },
    ],
  },
  {
    name: "お問い合わせ",
    icon: <HelpOutline />,
    options: [
      {
        name: "チャットボットに質問する",
      },
    ],
  },
];

export const staffAndPaymentProcedures: HumMenus[] = [
  {
    name: "法人職員に係るお手続き",
    icon: <Person />,
    options: [
      {
        name: "新規加入者の登録",
        path: "/SCRC070007",
        setBusinessType: "JOB-23",
      },
      {
        name: "従業状況の登録",
        path: "/SCRC070007",
        setBusinessType: "JOB-25",
      },
      {
        name: "配置換え情報の登録",
        path: "/SCRC070007",
        setBusinessType: "JOB-27",
      },
      {
        name: "本俸月額情報の登録（掛金届反映用）",
        path: "/SCRC070007",
        setBusinessType: "JOB-26",
      },
      {
        name: "退職した職員のお手続き",
        path: "/SCRC060118",
        setBusinessType: "JOB-32",
      },
    ],
  },
  {
    name: "掛金届に係るお手続き",
    icon: <Article />,
    options: [
      {
        name: "掛金届の確認・提出",
        path: "/SCRC080001",
        setBusinessType: "JOB-11",
      },
    ],
  },
];

export const facilitiesAndOtherProcedures: HumMenus[] = [
  {
    name: "施設に係るお手続き",
    icon: <CorporateFare />,
    options: [
      {
        name: "新しく施設・事業を開始した場合の届出",
        path: "/SCRC050101",
        setBusinessType: "JOB-15",
      },
      {
        name: "施設の名称や住所の変更が発生した場合の届出",
        path: "/SCRC050017",
        setBusinessType: "JOB-19",
      },
      {
        name: "施設種類を変更した場合の届出",
        path: "/SCRC050017",
        setBusinessType: "JOB-17",
      },
      {
        name: "施設を廃止した場合の届出",
        path: "/SCRC050120",
        setBusinessType: "JOB-18",
      },
    ],
  },
  {
    name: "その他のお手続き",
    icon: <ImportContacts />,
    options: [
      {
        name: "契約者の名称や住所の変更が発生した場合の届出",
        path: "/SCRC040002",
        setBusinessType: "JOB-05",
      },
      {
        name: "「俸給の調整額」の対象手当の登録",
        path: "/SCRC040103",
        setBusinessType: "JOB-07",
      },
      {
        name: "パスワード変更",
        path: "/SCRC010003",
        setBusinessType: "JOB-102",
      },
    ],
  },
];
